{
  "tasks": "Restoration Tasks",
  "pipelineTasks": "Pipeline Restoration Tasks",
  "tasksDescription": "Restore archived logs to be searched in $t(common:companyName).",
  "pipelineTasksDescription": "Restore archived data to pipeline.",
  "new": "New Restoration Task",
  "newPipeline": "New Pipeline Restoration Task",
  "begin": "Start",
  "name": "Name",
  "status": "Status",
  "retention": "Retention",
  "archive": "Archive",
  "pipelines": "Pipelines",
  "pipeline": "Pipeline",
  "node": "Node",
  "delete": "Delete {{name}}",
  "select": "Select files",
  "nameLabel": "Task name",
  "namePlaceholder": "Name your restoration task",
  "empty": "No Log Data Restoration Tasks Created Yet",
  "emptyDescription": "Click “New Restoration Task” above to start creating a new Log Restoration Task.",
  "unableToRetrieve": "Unable to retrieve tasks",
  "tryAgain": "Try again",
  "timeRange": "Time range (UTC)",
  "selected": "{{count}} selected",
  "noArchivesFound": "No archives found for selected time range",
  "fileCount": "{{count}} file",
  "fileCount_plural": "{{count}} files",
  "deleteTitle": "Delete <strong>{{ name }}</strong>?",
  "unsupportedConfig": "Current archiving configuration is not supported for Log Data Restoration.",
  "noArchiving": "Please enable and set up archiving to use Log Data Restoration.",
  "loadMore": "Load more",
  "createdAt": "Created",
  "expired": "Expired",
  "daysRemaining": "{{count}} day remaining",
  "daysRemaining_plural": "{{count}} days remaining",
  "view": "View Logs",
  "backToRehydratoinList": "Back to Restoration Tasks",
  "backToRehydrationListPipeline": "Back to Pipeline Restoration Tasks",
  "expiredTasksTitle": "Expired Tasks",
  "expiredTasksDescription": "The restored logs from expired restoration tasks are no longer searchable.",
  "restoreTaskSuccess": "Restoring the task {{name}}",
  "restoreTaskError": "Unable to restore {{name}}",
  "restore": "Restore",
  "statuses": {
    "error": "{{count}} Error",
    "error_plural": "{{count}} Errors",
    "success": "Success",
    "partialSuccess": "Partial success",
    "pending": "Pending",
    "processing": "Processing",
    "expired": "Expired",
    "unknown": "Unknown",
    "retry": "Retry"
  },
  "errors": {
    "noFilesSelected": "Please select at least one file.",
    "noTaskName": "Please name the restoration task.",
    "filesOverLimit": "Please select less files.",
    "maxLength": "Name must be less than 50 characters",
    "sizeOverLimit": "Please select less than {{ size }} of log volume"
  },
  "viewer": {
    "loading": "Loading...",
    "noTasksAvailable": "No restoration tasks available",
    "noTasksAvailableFound": "No restoration tasks found",
    "unableToLoad": "Unable to load this restoration task",
    "unableToLoadDescription": "There may be a typo in the URL, or this restoration task has expired.",
    "manageRehydrations": "Manage Restoration Tasks",
    "rehydratedLogs": "Restored Logs",
    "viewTasks": "View Restoration Tasks",
    "tasks": "Tasks",
    "newBadge": "NEW",
    "manage": "Manage Restorations",
    "placeholder": "Find a task"
  },
  "estimatedLogVolume": "Estimated log volume:",
  "estimatedVolume": "Estimated volume:",
  "archivingNotification": "Archiving must be enabled and configured with {{ supportedProviders }}",
  "status_error_message": "{{count}} file failed with the error: {{error}}",
  "status_error_message_plural": "{{count}} files failed with the error: {{error}}",
  "usageDashboard": {
    "title": "Log Data Restoration",
    "description": "Usage and cost breakdown for restoration tasks over the last 30 days",
    "table": {
      "title": "Usage Dashboard",
      "name": "Restoration task",
      "billingCycle": "Billing cycle",
      "size": "Size",
      "retention": "Retention",
      "costPerGB": "Cost per GB",
      "costTotal": "Cost total",
      "day": "{{ count }} day",
      "day_plural": "{{ count }} days",
      "billingCycleHint": "Retention task is included in this billing cycle"
    },
    "currentBillingCycle": "Current billing cycle",
    "mange": "Go to Manage Restorations Dashboard"
  }
}
